/**
 * PortalState.js
 *
 * Copyright (c) apploft. GmbH
 */

import handleAuthorize from './Authorize/handleAuthorize';
import handleAuthorized from './Authorize/handleAuthorized';
import handleCallback from './Authorize/handleCallback';

// States

import {unauthorized, authorizing, authorizingCallback} from './PortalStateSymbol';

// Events

import {
  authorize,
  authorizationSucceeded,
  authorizationFailed,
  authorizeCallback,
} from './PortalEventSymbol';

const containsAuthSessionStateToken = new RegExp(/state=([0-9a-f]+)/);
const dummyController = {abort: () => {}};

function init() {
  return {
    state: isAuthorizationCallback() ? authorizing : unauthorized,
    controller: dummyController,
  };
}

function reducer({state, data, controller}, {event, payload}) {
  switch (state) {
    case unauthorized:
      switch (event) {
        case authorize:
          return handleAuthorize(payload);

        default:
          break;
      }

      break;

    case authorizing:
    case authorizingCallback:
      controller.abort();
      switch (event) {
        case authorizeCallback:
          if (state === authorizing) {
            return handleCallback(payload);
          } else {
            break;
          }

        case authorizationFailed:
          return {state: unauthorized};

        case authorizationSucceeded:
          return handleAuthorized(payload);

        default:
          break;
      }

      break;

    default:
      break;
  }

  return {state, data, controller};
}

function isAuthorizationCallback() {
  return containsAuthSessionStateToken.test(window.location.search);
}

export {init, reducer};
